import { Route } from '@angular/router';
import { Shell } from '@ribera-web/shell';
// import { checkoutGuard } from '@ribera-web/booking-checkout-data-access';
// import { paymentGuard } from '@ribera-web/payments';
import { authGuard } from '@ribera-web/auth-data-acess';
import { paymentGuard } from '@ribera-web/payments';

export const appRoutes: Route[] = [
  {
    path: '',
    component: Shell,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('@ribera-web/home-feature').then((m) => m.homeFeatureRoutes),
      },
      {
        path: 'bookings',
        loadChildren: () =>
          import('@ribera-web/accommodation-feature').then(
            (m) => m.accommodationFeatureRoutes
          ),
      },
      {
        path: 'test-contact',
        loadChildren: () =>
          import('@ribera-web/contact-feature').then(
            (m) => m.contactFeatureRoutes
          ),
      },
      {
        path: 'test-about',
        loadChildren: () =>
          import('@ribera-web/about-feature').then((m) => m.aboutFeatureRoutes),
      },
      {
        path: 'promotions',
        loadChildren: () =>
          import('@ribera-web/promotions-feature').then(
            (m) => m.promotionsFeatureRoutes
          ),
      },
      {
        path: 'promos',
        redirectTo: 'promotions',
        pathMatch: 'full',
      },
      {
        path: 'promos/:slug',
        redirectTo: 'promotions',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/dashboard-feature').then(
            (m) => m.dashboardFeatureRoutes
          ),
      },
      {
        path: 'usage-policy-feature',
        loadChildren: () =>
          import('@ribera-web/usage-policy-feature').then(
            (m) => m.usagePolicyFeatureRoutes
          ),
      },
      {
        path: 'terms-conditions',
        loadChildren: () =>
          import('@ribera-web/terms-conditions-feature').then(
            (m) => m.termsConditionsFeatureRoutes
          ),
      },
      {
        path: 'acceptable-policies',
        loadChildren: () =>
          import('@ribera-web/acceptable-policies-feature').then(
            (m) => m.acceptablePoliciesFeatureRoutes
          ),
      },
      {
        path: 'usage-policy',
        loadChildren: () =>
          import('@ribera-web/usage-policy-feature').then(
            (m) => m.usagePolicyFeatureRoutes
          ),
      },
      {
        path: 'complaints-book',
        loadChildren: () =>
          import('@ribera-web/complaints-book-feature').then(
            (m) => m.complaintsBookFeatureRoutes
          ),
      },
      {
        path: 'services',
        loadChildren: () =>
          import('@ribera-web/ribera-services-shell').then(
            (m) => m.riberaServicesShellRoutes
          ),
      },
      {
        path: 'promotor',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/pre-register-feature').then(
            (m) => m.preRegisterFeatureRoutes
          ),
      },
      {
        path: 'checkout',
        loadChildren: () =>
          import('@ribera-web/booking-checkout-feature').then(
            (m) => m.bookingCheckoutFeatureRoutes
          ),
      },
      {
        path: 'member-booking-feature',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/member-booking-feature').then(
            (m) => m.memberBookingFeatureRoutes
          ),
      },
      {
        path: 'events',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/member-events-feature').then(
            (m) => m.memberEventsFeatureRoutes
          ),
      },
      {
        path: 'member-fullday-feature',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/member-fullday-feature').then(
            (m) => m.memberFulldayFeatureRoutes
          ),
      },
      {
        path: 'member-fullday-checkout',
        loadComponent: () =>
          import('@ribera-web/member-fullday-feature').then(
            (m) => m.CheckoutFullday
          ),
      },
      {
        path: 'member-fullday-voucher-upload/:bookingId',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@ribera-web/payments-feature').then(
            (m) => m.VoucherUploadFeature
          ),
      },
      {
        path: 'data',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/user-data-feature').then(
            (m) => m.userDataFeatureRoutes
          ),
      },
      {
        path: 'payment',
        canActivate: [paymentGuard],
        loadChildren: () =>
          import('@ribera-web/payments-feature').then(
            (m) => m.paymentsFeatureRoutes
          ),
      },
    ],
  },

  {
    path: 'auth',
    loadChildren: () =>
      import('@ribera-web/auth-shell').then((m) => m.authShellRoutes),
  },

  {
    path: 'previewUi',
    loadChildren: () =>
      import('@ribera-web/shared-preview-feature').then(
        (m) => m.sharedPreviewFeatureRoutes
      ),
  },

  {
    path: 'booking-history',
    loadChildren: () =>
      import('@ribera-web/booking-history-feature').then(
        (m) => m.bookingHistoryFeatureRoutes
      ),
  },
];
